import Vue from 'vue'
import Router from 'vue-router'

import Session from "../layouts/Session";
import Login from "../views/login/Login";

import Panel from "../layouts/IcevergPanel";
import IcevergSettings from "../views/settings/IcevergSettings";
import IcevergPlans from "../views/plans/IcevergPlans";
import StaffList from "../views/staff/List";
import StaffAdd from "../views/staff/AddProfile";
import StaffDetail from "../views/staff/Detail";
import StaffEdit from "../views/staff/EditProfile";
import ScoutingList from "../views/scouting/List";
import ScoutingAdd from "../views/scouting/AddProfile";
import ScoutingDetail from "../views/scouting/Detail";
import ScoutingEdit from "../views/scouting/EditProfile";
import JobMarketList from "../views/job-market/List";
import JobOffersList from "../views/job-offers/List";
import JobOfferDetail from "../views/job-offers/Detail";
import JobOfferSalaryReview from "../views/job-offers/SalaryReview";
import IcevergDashboard from "../views/dashboard/IcevergDashboard";
import Legal from "../views/legal/Legal";
import Privacy from "../views/legal/Privacy";
import goTo from 'vuetify/es5/services/goto'

import {set} from 'vue-gtag';
import {store} from '../store/store';

Vue.use(Router);

export const ROUTE_AFTER_LOGIN = '/dashboard';
export const ROUTE_AFTER_LOGOUT = '/';

let router = new Router({
  mode: 'history',
  scrollBehavior: (to, from, savedPosition) => {
    let scrollTo = 0;

    if (to.hash) {
      scrollTo = to.hash
    } else if (savedPosition) {
      scrollTo = savedPosition.y
    }

    let scrollingOptions = {
      duration: 1000,
      easing: 'easeInOutCubic'
    };

    return goTo(scrollTo, scrollingOptions)
  },
  routes: [
    {
      path: '/',
      component: Session,
      children: [
        {
          path: '/',
          component: Login,
          name: 'Login',
          meta: {
          }
        },
        {
          path: '/legal',
          component: Legal,
          meta: {
          }
        },
        {
          path: '/privacy',
          component: Privacy,
          meta: {
          }
        }
      ]
    },
    {
      path: '/dashboard',
      component: Panel,
      children: [
        {
          path: '',
          component: IcevergDashboard,
          meta: {
            requiresAuth: true,
          }
        }
      ]
    },
    {
      path: '/settings',
      component: Panel,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: '',
          component: IcevergSettings,
          name: 'settings'
        }
      ]
    },
    {
      path: '/plans',
      component: Panel,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: '',
          component: IcevergPlans,
          name: 'plans'
        }
      ]
    },
    {
      path: '/staff/',
      component: Panel,
      children: [
        {
          path: '/staff/list',
          component: StaffList,
          name: 'staffList',
          meta: {
            requiresAuth: true,

          }
        },
        {
          path: '/staff/add',
          component: StaffAdd,
          name: 'staffAdd',
          meta: {
            requiresAuth: true,
          }
        },
        {
          path: '/staff/:id',
          component: StaffDetail,
          name: 'staffDetail',
          meta: {
            requiresAuth: true,
          }
        },
        {
          path: '/staff/:id/edit',
          component: StaffEdit,
          name: 'staffEdit',
          meta: {
            requiresAuth: true,
          }
        },
      ]
    },
    {
      path: '/scouting/',
      component: Panel,
      children: [
        {
          path: '/scouting/list',
          component: ScoutingList,
          name: 'scoutingList',
          meta: {
            requiresAuth: true,

          }
        },
        {
          path: '/scouting/add',
          component: ScoutingAdd,
          name: 'scoutingAdd',
          meta: {
            requiresAuth: true,
          }
        },
        {
          path: '/scouting/:id',
          component: ScoutingDetail,
          name: 'scoutingDetail',
          meta: {
            requiresAuth: true,
          }
        },
        {
          path: '/scouting/:id/edit',
          component: ScoutingEdit,
          name: 'scoutingEdit',
          meta: {
            requiresAuth: true,
          }
        },
      ]
    },
    {
      path: '/job-market/',
      component: Panel,
      children: [
        {
          path: '/job-market/list',
          component: JobMarketList,
          name: 'jobMarketList',
          meta: {
            requiresAuth: true
          }
        },
      ]
    },
    {
      path: '/job-offers/',
      component: Panel,
      beforeEnter(to, from, next) {
        if(location.hostname.indexOf('iceverg.iceverg') > -1){
          next();
        } else {
          next({name: 'staffList'})
        }
      },
      children: [
        {
          path: '/job-offers/list',
          component: JobOffersList,
          name: 'jobOffersList',
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/job-offers/:id',
          component: JobOfferDetail,
          name: 'jobOfferDetail',
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/job-offers/:id/salary-review',
          component: JobOfferSalaryReview,
          name: 'jobOfferSalaryReview',
          meta: {
            requiresAuth: true
          }
        },

      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const token = localStorage.getItem('token');
    if (token === null) {
      next({name: 'Login'});
    } else {
      next();
    }
  } else {
    next();
  }
})

router.afterEach((to) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const userData = store.getters.getUserFromToken;
    // const userData = router.app.$store.getters('getUserFromToken');
    // console.log('userData', userData)
    set({
      'dimension1': userData.companyName,
      'dimension2': userData.name,
      'dimension3': `${userData.companyName} - ${userData.name}`
    })
  }
})

export default router;



// WEBPACK FOOTER //
// ./src/router/iceverg.js